export default __webpack_public_path__ + "static/media/13.8276f862.png";